import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  theme: "light",
  shareData: {},
  isTransparentLoading: false,
  isCreateModeifyWebsite: {},
  liveWebsiteUrl: "",
  isGeneratingWebsite: false,
  user_ai_limit: 0,
  isDeductLimit: "",
  userIdParent: "",
  isPaymentSuccess: false,
  userData: {},
  otpData: {},
  forgotPassword: {},
  createPassword: {},
  isFreeLimit: true,
  fetchUserData: "",
  isCodeView: false,
  saveDbStore: {},
  isSavedChanges: "",
  activeTab: null,
  // activeTab: typeof window !== "undefined" ? localStorage.getItem("activeTab") || "Chat" : "Chat",
  activeModel: typeof window !== "undefined" ? localStorage.getItem("activeModel") || "GPT-4o Mini" : "GPT-4o Mini",
  forStreamingHtml: "",
  globalLoading: false,
  uploadImage: "",
  projects: [],
  publicWithChats: [],
  showProjectPopup: false,
  isChatLoading: false,
};

const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setShareData: (state, action) => {
      state.shareData = action.payload
    },
    setIsTransparentLoading: (state, action) => {
      state.isTransparentLoading = action.payload
    },
    setIsCreateModeifyWebsite: (state, action) => {
      state.isCreateModeifyWebsite = action.payload
    },
    setLiveWebsiteUrl: (state, action) => {
      state.liveWebsiteUrl = action.payload
    },
    setIsGeneratingWebsite: (state, action) => {
      state.isGeneratingWebsite = action.payload
    },
    setUser_ai_limit: (state, action) => {
      state.user_ai_limit = action.payload
    },
    setIsDeductLimit: (state, action) => {
      state.isDeductLimit = action.payload
    },
    setUserIdParent: (state, action) => {
      state.userIdParent = action.payload
    },
    setIsPaymentSuccess: (state, action) => {
      state.isPaymentSuccess = action.payload
    },
    setActiveNavItem: (state, action) => {
      state.activeNavItem = action.payload
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload
    },
    setUserData: (state, action) => {
      state.userData = action.payload
    },
    setOtpData: (state, action) => {
      state.otpData = action.payload
    },
    setForgotPassword: (state, action) => {
      state.forgotPassword = action.payload
    },
    setCreatePassword: (state, action) => {
      state.createPassword = action.payload
    },
    setIsFreeLimit: (state, action) => {
      state.isFreeLimit = action.payload
    },
    setFetchUserData: (state, action) => {
      state.fetchUserData = action.payload
    },
    setActiveScreenId: (state, action) => {
      state.activeScreenId = action.payload
    },
    setIsCodeView: (state, action) => {
      state.isCodeView = action.payload
    },
    setSaveDbStore: (state, action) => {
      state.saveDbStore = action.payload
    },
    setIsSavedChanges: (state, action) => {
      state.isSavedChanges = action.payload
    },
    updateNewHtmlData(state, action) {
      // console.log('action.payload', action.payload);
      state.saveDbStore.new_html_data = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
      if (typeof window !== "undefined") {
      localStorage.setItem("activeTab", action.payload);
      }
    },
    setForStreamingHtml: (state, action) => {
      state.forStreamingHtml = action.payload
    },
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload
    },
    setUploadImage: (state, action) => {
      state.uploadImage = action.payload
    },
    setShowProjectPopup: (state, action) => {
      state.showProjectPopup = action.payload
    },
    setProjects: (state, action) => {
      state.projects = Array.isArray(action.payload) ? action.payload : [];
    },
    addProject: (state, action) => {
      state.projects = [action.payload, ...state.projects];
    },
    setIsChatLoading: (state, action) => {
    state.isChatLoading = action.payload;
    },
     setActiveModel: (state, action) => {
      state.activeModel = action.payload
      localStorage.setItem("activeModel", action.payload);
    },
  setPublicWithChats: (state, action) => {
  state.publicWithChats = action.payload;
},

  },
});

const initialHtmlState = {
  htmlContent: null,
};

export const htmlSlice = createSlice({
  name: "html",
  initialState: initialHtmlState,  // ✅ correct
  reducers: {
    setHtmlContentNew: (state, action) => {
      // console.log('action.payload chat', action.payload);
      state.htmlContent = action.payload;
    },
  },
});

export const { setUser, clearUser, setTheme, setShareData, setIsTransparentLoading, setIsCreateModeifyWebsite, setLiveWebsiteUrl, setIsGeneratingWebsite, setUser_ai_limit, setIsDeductLimit, setUserIdParent, setIsPaymentSuccess, setActiveNavItem, setActiveItem, setUserData, setOtpData, setForgotPassword, setCreatePassword, setIsFreeLimit, setFetchUserData, setIsRemoveLast, setActiveScreenId, setIsCodeView,
  setSaveDbStore, setIsSavedChanges, setActiveTab, setForStreamingHtml, setGlobalLoading, setUploadImage, setShowProjectPopup, setProjects, addProject, setIsChatLoading, setActiveModel, setPublicWithChats } = mainSlice.actions;
export default mainSlice.reducer;

export const { setHtmlContentNew } = htmlSlice.actions;
